import AdminLayout from "../AdminLayout";
import AdminDashPage from "../../ui/AdminDashBoard";
export default function AdminDashboard() {

  return (
    <AdminLayout>
      <AdminDashPage />
    </AdminLayout>
  );
}
